module.exports = __webpack_public_path__ + "static/1990-f6e9b09e3f7b9cf2a87bd67c357fc68e.webp";